import { Redirect, Route, RouteProps } from "react-router-dom";
import { Role } from "../enums";

type ProtectedRouteProps = RouteProps & {
  allowedRoles: Role[];
  userRole: Role;
};

/**
 * Redirects to `/unauthorized`
 * if the `userRole` does not match `allowedRoles`
 */
export function ProtectedRoute({
  children,
  allowedRoles,
  userRole,
  ...rest
}: ProtectedRouteProps) {
  return (
    <Route
      {...rest}
      render={() => {
        return allowedRoles.includes(userRole) ? (
          children
        ) : (
          <Redirect to="/unauthorized" />
        );
      }}
    />
  );
}
